// Preview helpers only. Not the product's D1 money calculation or channel pricing engine.
export function ruleError(rule, cats, items) {
  if (!rule || typeof rule.name !== 'string' || !rule.name.trim()) return 'Bitte einen Namen eingeben.';
  if (!['rabatt', 'karte'].includes(rule.type)) return 'Unbekannte Regelart.';
  if ((rule.cat != null && typeof rule.cat !== 'string') || (rule.item != null && typeof rule.item !== 'string')) return 'Ungültige Artikel- oder Kategoriezuordnung.';
  if (!Array.isArray(rule.days) || !rule.days.length || rule.days.some(d => !Number.isInteger(d) || d < 0 || d > 6)) return 'Bitte gültige Wochentage auswählen.';
  const time = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
  if (!time.test(rule.from) || !time.test(rule.to)) return 'Uhrzeiten bitte als HH:MM eingeben.';
  if (rule.from >= rule.to) return 'Diese Vorschau unterstützt nur Zeitfenster mit Ende nach Beginn am selben Tag.';
  if (rule.type === 'rabatt') {
    const raw = String(rule.val).trim();
    const amount = Number(raw.replace(',', '.'));
    if (!/^\d+(?:[,.]\d{1,2})?$/.test(raw) || !Number.isFinite(amount) || amount <= 0) return 'Bitte einen positiven Nachlass mit höchstens zwei Nachkommastellen eingeben.';
    if (!['pct', 'eur'].includes(rule.mode)) return 'Bitte Prozent oder Euro auswählen.';
    if (rule.mode === 'pct' && amount > 100) return 'Ein prozentualer Nachlass darf höchstens 100 % betragen.';
  }
  if (cats && items) {
    if (rule.item && rule.type === 'rabatt') {
      if (!items.some(a => a.n === rule.item)) return 'Der ausgewählte Artikel ist nicht mehr im Katalog. Bitte neu zuordnen.';
    } else if (!cats.some(c => c.id !== 'all' && c.n === rule.cat)) return 'Bitte eine vorhandene Kategorie auswählen.';
  }
  return '';
}
export function ruleInWindow(rule, date = new Date()) {
  if (ruleError(rule)) return false;
  const day = (date.getDay() + 6) % 7;
  const hm = String(date.getHours()).padStart(2, '0') + ':' + String(date.getMinutes()).padStart(2, '0');
  // Preserve original minute-inclusive preview. Product boundary/booking-time policy remains open.
  return rule.days.includes(day) && hm >= rule.from && hm <= rule.to;
}
export function rulePreviewPrice(cents, rule) {
  if (ruleError(rule) || !Number.isSafeInteger(cents) || cents < 0) return null;
  const amount = Number(String(rule.val).replace(',', '.'));
  if (rule.type !== 'rabatt') return cents;
  return rule.mode === 'eur' ? Math.max(0, cents - Math.round(amount * 100)) : Math.round(cents * (1 - amount / 100) / 10) * 10;
}
// The establishment/device adapter can replace this local preview source. No native IPC or backend.
export function createPriceRuleSource(storage, dayOne = false) {
  const key = biz => 'zalso.pricerules.' + (dayOne ? 'day1.' : '') + biz;
  return {
    load(biz, defaults) {
      const raw = storage.getItem(key(biz));
      if (raw === null) return structuredClone(defaults);
      const value = JSON.parse(raw);
      if (!Array.isArray(value) || value.some(r => !r || typeof r.id !== 'string' || !r.id || typeof r.on !== 'boolean' || ruleError(r)) || new Set(value.map(r => r.id)).size !== value.length) throw Error('Gespeicherte Preisregeln sind ungültig. Der Speicher wurde nicht überschrieben.');
      return value;
    },
    save(biz, rules) { storage.setItem(key(biz), JSON.stringify(rules)); }
  };
}
